var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner-list-link',{attrs:{"listLayout":_vm.listLayout,"bannerData":_vm.bannerData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }